import {
	isDeploymentSiteCode,
	normalizeLegacyDeploymentSiteCode,
} from "le-coffre-resources/dist/deploymentSiteCodes.js";

/**
 * Build-time deployment site for theming and layout hooks (must match backend process `SITE_CODE` / `NEXT_PUBLIC_SITE_CODE` alignment).
 */
export function getPublicSiteCode(): string {
	const code = typeof process !== "undefined" ? process.env["NEXT_PUBLIC_SITE_CODE"] : undefined;
	if (typeof code === "string" && code.trim().length > 0) {
		const n = normalizeLegacyDeploymentSiteCode(code);
		if (!isDeploymentSiteCode(n)) {
			throw new Error(
				`NEXT_PUBLIC_SITE_CODE must be lecoffreio (got: ${code.trim()}). Use lecoffreio for the notaire line; kogus is only under .secrets/kogus/.`,
			);
		}
		return n;
	}
	throw new Error("NEXT_PUBLIC_SITE_CODE is required at build time (lecoffreio).");
}
